import type { ReactElement } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IRadioSelectItem } from "app/pages/sales-intelligence/common-components/form-fields";
import { HorizontalRadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";

import type { AppsPriceType } from "../../../../../types/commonFiltersDto";

const NO_VALUE_OPTION = "noValue";

type PriceTypeValue = AppsPriceType | undefined;

interface IProps {
    options: readonly AppsPriceType[];
    value?: PriceTypeValue;
    onChange: (value?: PriceTypeValue) => void;
}

const PriceTypeFilter = ({ value, options, onChange }: IProps): ReactElement => {
    const allOptions = useMemo((): IRadioSelectItem[] => {
        return [NO_VALUE_OPTION, ...options].map(
            (option: string): IRadioSelectItem => ({
                id: option,
                text: translate(`si.find_apps.filters.price.${option}.label`),
            }),
        );
    }, [options]);

    const handleValueChange = (newValue: PriceTypeValue | string): void => {
        if (newValue === NO_VALUE_OPTION) {
            onChange();
            return;
        }

        onChange(newValue as PriceTypeValue);
    };

    return (
        <div>
            <HorizontalRadioSelect
                size="sm"
                items={allOptions}
                selected={value || NO_VALUE_OPTION}
                onSelect={handleValueChange}
            />
        </div>
    );
};

export default PriceTypeFilter;
